import { Paper, Stack, Typography } from "@mui/material";

export const CreditCheckField = ({ label, value, sx }) => (
  <Paper variant="outlined" sx={{ my: 1, p: 1, ...sx }}>
    <Stack textAlign="center" spacing={1}>
      <Typography variant="subtitle2">{label}</Typography>
      <Typography variant="h6">{value}</Typography>
    </Stack>
  </Paper>
);
